import request from '@/utils/request'
import URL from '@/api/urlTranslator'

// 平台操作指令
export function queryAllPlatformInstructionByTenant(data) {
  return request({
    url: URL.sys.queryAllPlatformInstructionByTenant,
    method: 'post',
    data
  })
}

export function queryPlatformInstruction(data) {
  return request({
    url: URL.sys.queryPlatformInstruction,
    method: 'post',
    data
  })
}

export function savePlatformInstruction(data) {
  return request({
    url: URL.sys.savePlatformInstruction,
    method: 'post',
    data
  })
}

export function deletePlatformInstruction(data) {
  return request({
    url: URL.sys.deletePlatformInstruction,
    method: 'post',
    data
  })
}

// 租户操作指令
export function queryAllTenantInstruction(data) {
  return request({
    url: URL.sys.queryAllPlatformInstruction,
    method: 'post',
    data
  })
}

export function queryTenantInstruction(data) {
  return request({
    url: URL.sys.queryTenantInstruction,
    method: 'post',
    data
  })
}

export function saveTenantInstruction(data) {
  return request({
    url: URL.sys.saveTenantInstruction,
    method: 'post',
    data
  })
}

export function deleteTenantInstruction(data) {
  return request({
    url: URL.sys.deleteTenantInstruction,
    method: 'post',
    data
  })
}

// 特定业务规则
export function querySpecificBusinessRuleByTenant(data) {
  return request({
    url: URL.sys.querySpecificBusinessRuleByTenant,
    method: 'post',
    data
  })
}

export function querySpecificBusinessRule(data) {
  return request({
    url: URL.sys.querySpecificBusinessRule,
    method: 'post',
    data
  })
}

export function saveSpecificBusinessRule(data) {
  return request({
    url: URL.sys.saveSpecificBusinessRule,
    method: 'post',
    data
  })
}

export function deleteSpecificBusinessRule(data) {
  return request({
    url: URL.sys.deleteSpecificBusinessRule,
    method: 'post',
    data
  })
}

// 获取操作指令日志
export function getInstructionRecordsByJobUuid(params) {
  return request({
    url: URL.sys.getInstructionRecordsByJobUuid,
    method: 'get',
    params
  })
}

// 生成操作指令日志
export function generateInstructionRecord(data) {
  return request({
    url: URL.sys.generateInstructionRecord,
    method: 'post',
    data
  })
}
